import { render, staticRenderFns } from "./create-question-pop.vue?vue&type=template&id=d2122e8c&scoped=true&"
import script from "./create-question-pop.vue?vue&type=script&lang=js&"
export * from "./create-question-pop.vue?vue&type=script&lang=js&"
import style0 from "./create-question-pop.vue?vue&type=style&index=0&id=d2122e8c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2122e8c",
  null
  
)

export default component.exports